<div class="container-fluid p-4">

  <fieldset class="shadow p-3 rounded-5" style="border: 2px solid #63b1bc">
    <legend class="float-none w-auto p-1 mx-5 fw-bold fs-1" style="color: #003057">
      {{data.title}}
    </legend>
    <!--
  <button mat-icon-button class="close-button float-end" mat-dialog-close>
    <mat-icon class="close-icon" >close</mat-icon>
  </button>
-->
    <mat-dialog-content [innerHtml]="data.content | preserveHtml">

    </mat-dialog-content>
    <mat-dialog-actions *ngIf="data.title =='Session Timer'" class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button mat-raised-button [mat-dialog-close]="false">End Session</button>
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Extend</button>
    </mat-dialog-actions>
    <mat-dialog-actions *ngIf="data.title =='Family Member' || data.title=='Medicaid Member Required'"     class="d-grid gap-2 d-md-flex justify-content-md-end">
      <button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Close</button>
    </mat-dialog-actions>
  </fieldset>
</div>
